// MUI
import { Box } from '@mui/material';
import RecordVideo from 'components/RecordVideo';

const TakeVideoItem = ({ value }) => {
  const colors = {
    pass: 'rgba(76, 175, 80, 1)',
    fail: 'rgba(239, 83, 80, 1)',
    na: 'rgba(0, 0, 0, 0.6)',
  };

  return (
    <Box
      sx={{
        fontWeight: 500,
        fontSize: '13px',
        color: '#fff',
        letterSpacing: '0.15px',
        background: colors[value],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
      }}
    >
      <RecordVideo
        attachments={value ?? []}
        onChangeCb={() => {
          console.log('');
        }}
        isPreview={true}
      />
    </Box>
  );
};

export default TakeVideoItem;
